import React, { useState } from "react";
import { BiPlus, BiRefresh, BiSearch, BiChevronLeft, BiChevronRight } from "react-icons/bi";

const StatusBadge = ({ status }) => {
  const map = {
    1: { bg: "bg-green-100", text: "text-green-800", label: "Aktif" },
    2: { bg: "bg-red-100",   text: "text-red-800",   label: "Nonaktif" },
    3: { bg: "bg-gray-100",  text: "text-gray-600",  label: "Terhapus" },
  };
  const s = map[status] || map[3];
  return (
    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${s.bg} ${s.text}`}>
      {s.label}
    </span>
  );
};

const ActionCell = ({ row, onEdit, onAction, onDelete, onPrintBarcode }) => {
  if (row.Status === 3) {
    return (
      <span className="px-2 py-1 bg-gray-200 text-gray-500 rounded text-xs">
        Terhapus
      </span>
    );
  }
  return (
    <div className="flex gap-1">
      <button
        onClick={() => onEdit(row)}
        className="px-2 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-xs"
      >
        Edit
      </button>
      <button
        onClick={() => onPrintBarcode(row)}
        title={row.Barcode ? `Cetak barcode ${row.Barcode}` : "Barang ini belum punya barcode"}
        className={`px-2 py-1 rounded text-xs text-white ${
          row.Barcode
            ? "bg-indigo-500 hover:bg-indigo-600"
            : "bg-gray-300 hover:bg-gray-400"
        }`}
      >
        Barcode
      </button>
      <button
        onClick={() => onAction(row)}
        className={`px-2 py-1 rounded text-xs text-white ${
          row.Status === 1 ? "bg-yellow-500 hover:bg-yellow-600" : "bg-green-500 hover:bg-green-600"
        }`}
      >
        {row.Status === 1 ? "Non" : "Aktif"}
      </button>
      <button
        onClick={() => onDelete(row)}
        className="px-2 py-1 bg-red-500 hover:bg-red-600 text-white rounded text-xs"
      >
        Hapus
      </button>
    </div>
  );
};

const thClass =
  "font-bold px-4 py-3 align-middle border-b-2 border-solid border-blue-900 whitespace-nowrap text-left text-base";
const tdClass =
  "border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-4 py-2 text-left";

const TableMasterBarang = ({
  data = [],
  onEdit = () => {},
  onAction = () => {},
  onDelete = () => {},
  onPrintBarcode = () => {},
  onAdd,
  isLoading,
  onPageChange,
  onPerRowsChange,
  totalRows,
  currentPage,
  perPage,
  search,
  onSearchChange,
  onRefresh,
}) => {
  const [filterText, setFilterText] = useState(search || "");

  const formattedData = data.map((item, index) => ({
    ...item,
    no: (currentPage - 1) * perPage + index + 1,
  }));

  const totalPages = Math.ceil(totalRows / perPage);
  const rowOptions = [10, 25, 50, 100];

  return (
    <div>
      {/* Subheader */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4">
        <div className="flex items-center gap-2 w-full sm:w-auto">
          <div className="relative">
            <BiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
            <input
              type="text"
              placeholder="Cari barang..."
              value={filterText}
              onChange={(e) => {
                setFilterText(e.target.value);
                onSearchChange?.(e.target.value);
              }}
              className="pl-9 pr-4 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-64"
            />
          </div>
          {filterText && (
            <button
              onClick={() => { setFilterText(""); onSearchChange?.(""); }}
              className="px-3 py-2 text-xs bg-gray-100 hover:bg-gray-200 text-gray-600 rounded-lg border border-gray-300"
            >
              Hapus
            </button>
          )}
          <button
            onClick={onRefresh}
            disabled={isLoading}
            title="Refresh"
            className="p-2 bg-gray-100 hover:bg-gray-200 text-gray-600 rounded-lg border border-gray-300 disabled:opacity-50"
          >
            <BiRefresh className={`text-lg ${isLoading ? "animate-spin" : ""}`} />
          </button>
        </div>

        <button
          onClick={onAdd}
          disabled={isLoading}
          className="flex items-center gap-1 px-4 py-2 bg-white hover:bg-gray-100 text-gray-800 font-semibold border border-gray-400 rounded shadow text-sm disabled:opacity-50"
        >
          <BiPlus className="text-base" />
          Tambah
        </button>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="table-auto w-full bg-transparent border-collapse text-sm">
          <thead>
            <tr style={{ backgroundColor: "#1e3a5f" }}>
              <th className={thClass} style={{ color: "#fb923c" }}>No</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Barang ID</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Nama Barang</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Spesifikasi</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Jenis</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Bagian</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Barcode</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Kelompok</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Detail Account</th>
              <th className={thClass} style={{ color: "#fb923c" }}>COA Hutang</th>
              <th className={thClass} style={{ color: "#fb923c" }}>COA Beban</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Tipe</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Satuan</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Min Qty</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Part No</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Status</th>
              <th className={thClass} style={{ color: "#fb923c" }}>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={17} className="text-center py-12 text-gray-400">
                  Memuat data...
                </td>
              </tr>
            ) : formattedData.length === 0 ? (
              <tr>
                <td colSpan={17} className="text-center py-12 text-gray-400">
                  <div className="flex flex-col items-center gap-3">
                    <span>Tidak ada data barang</span>
                    <button
                      onClick={onAdd}
                      className="flex items-center gap-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm"
                    >
                      <BiPlus />
                      Tambah Barang
                    </button>
                  </div>
                </td>
              </tr>
            ) : (
              formattedData.map((row) => (
                <tr key={row.BarangID} className="hover:bg-gray-50">
                  <td className={tdClass + " text-gray-500 text-xs"}>{row.no}</td>
                  <td className={tdClass + " font-mono text-xs"}>{row.BarangID}</td>
                  <td className={tdClass}>{row.BarangName}</td>
                  <td className={tdClass + " text-gray-600"}>{row.SpesifikasiBarang || "-"}</td>
                  <td className={tdClass}>{row.JenisBarang}</td>
                  {/* Bagian = nama dari MBagian; kodenya (KodeJenisBarang)
                      ditampilkan kecil sebagai keterangan. */}
                  <td className={tdClass}>
                    {row.NamaBagian ? (
                      <span title={row.KodeJenisBarang}>{row.NamaBagian}</span>
                    ) : (
                      <span className="font-mono bg-gray-100 px-1 rounded text-xs">
                        {row.KodeJenisBarang || "-"}
                      </span>
                    )}
                  </td>
                  <td className={tdClass + " font-mono text-xs"}>
                    {row.Barcode || <span className="text-gray-400">-</span>}
                  </td>
                  <td className={tdClass}>{row.KelompokName}</td>
                  <td className={tdClass + " text-gray-600"}>{row.NamaDetailAccount}</td>
                  <td className={tdClass + " text-gray-600"}>{row.NamaLawanAccount || "-"}</td>
                  <td className={tdClass + " text-gray-600"}>{row.NamaLawanBebanAccount || "-"}</td>
                  <td className={tdClass + " text-center"}>{row.Tipe || "-"}</td>
                  <td className={tdClass + " text-center"}>{row.SatuanName}</td>
                  <td className={tdClass + " text-right"}>{row.MinQty || 0}</td>
                  <td className={tdClass + " font-mono text-xs"}>{row.PartNumber || "-"}</td>
                  <td className={tdClass + " text-center"}>
                    <StatusBadge status={row.Status} />
                  </td>
                  <td className={tdClass}>
                    <ActionCell
                      row={row}
                      onEdit={onEdit}
                      onAction={onAction}
                      onDelete={onDelete}
                      onPrintBarcode={onPrintBarcode}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {!isLoading && totalRows > 0 && (
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 mt-4 pt-3 border-t border-gray-200 text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <span>Tampilkan</span>
            <select
              value={perPage}
              onChange={(e) => onPerRowsChange?.(Number(e.target.value), 1)}
              className="border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              {rowOptions.map((n) => (
                <option key={n} value={n}>{n}</option>
              ))}
            </select>
            <span>
              dari <strong>{totalRows}</strong> data
            </span>
          </div>

          <div className="flex items-center gap-1">
            <button
              onClick={() => onPageChange?.(currentPage - 1)}
              disabled={currentPage <= 1}
              className="p-1.5 rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
            >
              <BiChevronLeft className="text-lg" />
            </button>
            <span className="px-3 py-1 text-sm">
              Hal {currentPage} / {totalPages}
            </span>
            <button
              onClick={() => onPageChange?.(currentPage + 1)}
              disabled={currentPage >= totalPages}
              className="p-1.5 rounded border border-gray-300 hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
            >
              <BiChevronRight className="text-lg" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TableMasterBarang;
